import { memo } from 'react';
import classNames from 'classnames';
import { useWindowSize } from 'usehooks-ts';

import { NAVBAR_LINKS } from '../../../data/nav';
import { ALL_TOOLS } from '../../../data/tools';
import { AnalyticsGTM } from '../../../services/analytics-gtm';
import { SingleToolLogo } from '../SingleToolLogo';
import { INavSubLink, MENU_COLLAPSE_BREAKPOINT } from '../SingleToolNavigation';
import { SingleToolNavigationDesktop, SingleToolNavigationMobile } from '../SingleToolNavigation';
import ShareButton from '../Widgets/ShareButton';
import { SingleToolSearchDesktop } from '../SingleToolSearch';
import { LoginArea } from '../Login';

import useStyles from './style';

interface ISingleToolHeader {
  className?: string;
  goToLink?: (link: INavSubLink) => void;
  noBorder?: boolean;
  toolName?: string;
  pageName?: string;
  shareName?: string;
  analytics?: AnalyticsGTM;
  widgetUrl?: string;
  hasLogin?: boolean;
}

function SingleToolHeader({
  className,
  noBorder,
  analytics,
  toolName,
  pageName,
  shareName,
  widgetUrl,
  hasLogin,
}: ISingleToolHeader) {
  const { width } = useWindowSize();
  const classes = useStyles({ noBorder });
  const shareButtonToolName = shareName ?? ALL_TOOLS.filter((tool) => tool.id == toolName)[0]?.name;

  if (width >= MENU_COLLAPSE_BREAKPOINT) {
    return (
      <header className={classNames(classes.root, className)}>
        <div className={classes.container}>
          <div className={classes.navContainer}>
            <SingleToolLogo className={classes.logo} href="/" />
            <SingleToolNavigationDesktop
              items={NAVBAR_LINKS}
              analytics={analytics}
              toolName={toolName}
              pageName={pageName}
            />
          </div>
          <div className={classes.buttonsContainer}>
            <SingleToolSearchDesktop
              analytics={analytics}
              toolName={toolName}
              pageName={pageName}
              collabsable
            />
            <ShareButton
              analytics={analytics}
              toolName={shareButtonToolName ?? toolName}
              widgetUrl={widgetUrl}
            />
            {hasLogin && <LoginArea analytics={analytics} />}
          </div>
        </div>
      </header>
    );
  }

  return (
    <header className={classNames(classes.root, className)}>
      <div className={classes.container}>
        <div className={classes.mobileContainer}>
          <SingleToolNavigationMobile
            analytics={analytics}
            toolName={toolName}
            pageName={pageName}
          />
          <SingleToolLogo className={classes.logo} href="/" />
        </div>

        <div className={classes.mobileContainer}>
          <ShareButton
            analytics={analytics}
            toolName={shareButtonToolName ?? toolName}
            widgetUrl={widgetUrl}
          />
          {hasLogin && <LoginArea analytics={analytics} />}
        </div>
      </div>
    </header>
  );
}

export default memo(SingleToolHeader);
